module.exports = __webpack_public_path__ + "img/e528cf1.jpg";